import { EventEmitter, Inject, Injectable } from '@angular/core';

import { ACTIVE_THEME, Theme, THEMES } from '../models/theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  change = new EventEmitter<Theme>();
  inPreview = false;

  constructor(@Inject(THEMES) public themes: Theme[], @Inject(ACTIVE_THEME) private theme: Theme) {}

  get activeTheme(): Theme {
    return this.theme;
  }

  getTheme(id: number): Theme {
    const theme = this.themes.find((t) => t.id === id);
    if (!theme) {
      throw new Error(`Theme not found: '${id}'`);
    }
    return theme;
  }

  getThemeByName(name: string): Theme {
    const theme = this.themes.find((t) => t.name === name);
    if (!theme) {
      throw new Error(`Theme not found: '${name}'`);
    }
    return theme;
  }

  registerTheme(theme: Theme) {
    this.themes.push(theme);
  }

  setTheme(theme: Theme) {
    if (theme !== this.theme) {
      this.theme = theme;
      this.change.emit(this.activeTheme);
    }
  }

  updateTheme(id: number, properties: { [key: string]: string }): Theme {
    const theme = this.getTheme(id);
    theme.properties = {
      ...theme.properties,
      ...properties
    };

    if (id === this.activeTheme.id) {
      this.theme = theme;
      this.change.emit(theme);
    }

    return theme;
  }
}
